import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import { getIconByType } from '../../../mapComponents/Popups/PopupUtil';
import { compose } from 'recompose';
import Tooltip from '../../../common/StyledToolTip';

const styles = () => ({
  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }
});

const SpecialNeedsRenderer = ({ iconsList, theme, classes }) => {
  if (!iconsList.length) return <div>-</div>;
  return (
    <div className={classes.iconsContainer}>
      {iconsList.map((icon, index) => {
        const renderedIcon = getIconByType({
          iconData: icon,
          backgroundColor: theme.dispatchPanelLabelValueColor
        });
        const title = icon.tooltip ?? icon.text ?? '';
        return title ? (
          <Tooltip key={index} title={title}>
            <span>{renderedIcon}</span>
          </Tooltip>
        ) : (
          <span key={index}>{renderedIcon}</span>
        );
      })}
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(SpecialNeedsRenderer);
